import React from 'react';
import './blog-post.css';
import google1 from './pictures/google1.JPG';
import google2 from './pictures/google2.JPG';
import google3 from './pictures/google3.JPG';
import google4 from './pictures/google4.JPG';
import google5 from './pictures/google5.JPG';
import google6 from './pictures/google6.JPG';


//import reportWebVitals from './reportWebVitals';

const GoogleSplunk22Recap = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Splunk Technical Interview Workshop & Meet Women Engineers at Google Event Recaps</h2>
                    <p className="site-post-meta">November 10, 2022</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        Last week we put on two company events! For those of you who could not make it,
                        here is a recap on all that we did.
                    </p>
                    <p>
                        On November 1st, we hosted a Technical Interview Workshop with Splunk! Three panelists
                        from Splunk came to present to WiC members about tips and tricks related to both
                        Behavioral and Technical Interviewing. We learned about how to best answer behavioral
                        questions and how to approach technical coding questions. Members also had the opportunity
                        to ask current Splunk engineers and recruiters questions about Splunk and internship
                        opportunities.
                    </p>
                    <p>
                        Then on November 3rd, we hosted our Meet Women Engineers Panel with Google! Three current
                        Google employees came to answer questions related to the company, as well as being an engineer
                        and a woman in CS.
                    </p>
                    <p>
                        Thank you so much to everyone who attended - we hope you learned a lot about technical
                        interviewing, being an engineer and opportunities at both Splunk and Google! We also wanna give
                        a huge thank you to Splunk and Google for taking the time to speak with us and teach us so much,
                        we appreciate it!
                    </p>
                    <img src={google2} alt="WiC Members listening to company speakers" />
                    <img src={google6} alt="Group with WiC members and Google Panelists" />
                    <img src={google3} alt="Panelists speaking to students" />
                    <img src={google4} alt="Google Panelists" />
                    <img src={google1} alt="Google Panelists" />
                    <img src={google5} alt="Company Swag" />
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default GoogleSplunk22Recap;